import * as React from 'react';

const SvgComponent = props => (
  <svg
    width={85}
    height={85}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M74.314 5H11.721c-3.42 0-6.409 2.46-6.409 5.841v62.732c0 3.398 2.989 6.427 6.409 6.427h62.575c3.438 0 6.016-3.049 6.016-6.427V10.841C80.332 7.461 77.734 5 74.314 5ZM28.561 67.516H17.816V34.11h10.745v33.407Zm-5-38.486h-.078c-3.438 0-5.665-2.56-5.665-5.764 0-3.263 2.285-5.762 5.8-5.762 3.517 0 5.668 2.48 5.745 5.762-.002 3.204-2.229 5.764-5.803 5.764Zm44.268 38.486H57.084V49.25c0-4.376-1.563-7.366-5.45-7.366-2.97 0-4.728 2.009-5.51 3.966-.293.703-.372 1.66-.372 2.638v19.028H35.008V34.11h10.744v4.65c1.564-2.227 4.006-5.431 9.69-5.431 7.053 0 12.388 4.648 12.388 14.671l-.001 19.517Z'
      fill='#fff'
    />
  </svg>
);

export default SvgComponent;
